import Grid from "@mui/material/Grid";
import {Item} from "../CharStyled";
import TextField from "@mui/material/TextField";
import React from "react";
import {useSignals} from "@preact/signals-react/runtime";
import updChar from "../../_sig_api/updChar";
import {displayVerteidigungModNSC} from "../../_helper/displayVerteidigungModNSC";
import {s_char} from "../../_signals/s_char";

export default function CharKVNSC() {
    useSignals();
    return <Grid item sm={2} xs={4}>
        <Item>
            <TextField InputLabelProps={{shrink: true}}
                       onChange={e => updChar([{k:'kv', v:parseInt(e.target.value)}])}
                       style={{marginLeft: 8, maxWidth: 80}}
                       value={s_char.value.kv}
                       variant="standard" type="number" label="K Vert:" id="kv"
                       name="kv"/>
            {displayVerteidigungModNSC('kv')}
        </Item>
    </Grid>;
}